import { FormSpy } from 'react-final-form';
import { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ErknmFieldMark } from 'KnmErknmPackage/MainModule/components/ErknmFieldMark';
import { APPROVED_ON_PAPER_DOCUMENTS_BLOCK_ID } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';

import { IKnmFormRef } from '../interfaces/IKnmFormRef';

interface IErknmApprovedOnPaperAttachmentProps {
  formRef: IKnmFormRef | undefined;
  watchOnly: boolean;
}

const ErknmApprovedOnPaperAttachmentWithoutStore = ({ formRef, watchOnly }: IErknmApprovedOnPaperAttachmentProps) => {
  const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

  const handleOpenSignModal = useCallback(() => {
    setIsVisibleSignModal(true);
  }, []);

  const handleCloseSignModal = useCallback(() => {
    setIsVisibleSignModal(false);
  }, []);

  return (
    <Row margin="medium" isListItem>
      <div className="shared-deleting-row">
        <FieldBlock
          id={APPROVED_ON_PAPER_DOCUMENTS_BLOCK_ID}
          label={
            <>
              {'Решение прокурора (на бумаге)'}
              <ErknmFieldMark fieldName="approvedOnPaperDocuments.attachments" />
            </>
          }
          button={
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              disabled={watchOnly}
              onClick={handleOpenSignModal}
            />
          }
        ></FieldBlock>
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError =
              props.errors?.approvedOnPaperDocuments && props.errors?.approvedOnPaperDocuments?.attachments;
            const isFieldTouched = props.touched?.places;

            if (isFieldTouched && fieldError) {
              return <p className="shared-input-error shared-row__small-margin">{fieldError}</p>;
            }

            return null;
          }}
        </FormSpy>
        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={`approvedOnPaperDocuments.attachments`}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={handleCloseSignModal}
          formRef={formRef}
        />
      </div>
    </Row>
  );
};

export const ErknmApprovedOnPaperAttachment = connect()(ErknmApprovedOnPaperAttachmentWithoutStore);
